import { render, staticRenderFns } from "./VacancyHabilities.vue?vue&type=template&id=8dc39bd2&scoped=true"
import script from "./VacancyHabilities.vue?vue&type=script&lang=js"
export * from "./VacancyHabilities.vue?vue&type=script&lang=js"
import style0 from "./VacancyHabilities.vue?vue&type=style&index=0&id=8dc39bd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dc39bd2",
  null
  
)

export default component.exports